import axios from "axios";
import {
  API_URL_BASE,
  KEYCLOAK_REALM,
  KEYCLOAK_URL,
  KEYCLOAK_CLIENT_ID,
} from "../constants/config";

const Keycloak = require("keycloak-js");
//require('../utils/keycloak');

export const keycloak = new Keycloak({
  realm: KEYCLOAK_REALM,
  url: KEYCLOAK_URL,
  clientId: KEYCLOAK_CLIENT_ID,
});

const axiosInstance = axios.create({
  baseURL: API_URL_BASE,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  function (config) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${keycloak.token}`,
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let count = 0;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && count < 4) {
      count++;
      //Refresh token
      return keycloak
        .updateToken(300)
        .then(function () {
          originalRequest.headers["Authorization"] = "Bearer " + keycloak.token;
          //run original request
          return axiosInstance(originalRequest);
        })
        .catch(function (e) {});
    }
    if (count >= 4) {
      keycloak.logout();
    }
    count = 0;
    return Promise.reject(error);
  }
);

export default axiosInstance;
